import React, { useEffect, Suspense, useState, useContext } from "react";
import { Redirect, Route, Switch, withRouter } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import {SocketContext} from 'context/socket';
import TagManager from 'react-gtm-module';

import "font-awesome/css/font-awesome.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useTranslation } from 'react-i18next';
import queryString from 'query-string'

import "./assets/scss/general.scss";

import * as actions from "./store/actions";

import Loader from './components/Loader/Loader'
import ModalUpdatingContent from "components/ModalUpdatingContent";
import FeedbackForm from "components/FeedbackForm/FeedbackForm";

const RegFrame = React.lazy(() => import("./views/pages/RegFrame/RegFrame")) ;
const RegFrameDetail = React.lazy(() => import("./views/pages/RegFrameDetail/RegFrameDetail")) ;
const Login = React.lazy(() => import("./views/pages/Login/Login")) ;
const Notification = React.lazy(() => import("./views/pages/Notification/Notification")) ;
const RegulationDetail = React.lazy(() => import("./views/pages/Regulation/RegulationDetail")) ;
const Settings = React.lazy(() => import("./views/pages/Settings/Settings")) ;
const SettingNotification = React.lazy(() => import("./views/pages/SettingNotification/SettingNotification")) ;
const ThemeSetting = React.lazy(() => import("./views/pages/Settings/ThemeSetting/ThemeSetting")) ;
const SubscriptionUpdate = React.lazy(() => import("./views/pages/Settings/UpdateSubscription/UpdateSubscription"));
// const BlankPage = React.lazy(() => import()) './views/pages/BlankPage/BlankPage';
const page403 = React.lazy(() => import("./views/pages/403page/403page")) ;
const page404 = React.lazy(() => import("./views/pages/404page/404page")) ;
const Layout = React.lazy(() => import("./components/Layout/Layout")) ;
const CustomerManagement = React.lazy(() => import("./views/pages/CustomerManagement/CustomerManagement")) ;
const DetailCustomer = React.lazy(() => import("./views/pages/CustomerManagement/components/EditCustomer/EditCustomer")) ;
const UserManagement = React.lazy(() => import("./views/pages/UserManagement/UserManagement")) ;
const DetailGroup = React.lazy(() => import("./views/pages/UserManagement/components/GroupTable/components/DetailGroup/DetailGroup")) ;
const AccountSettings = React.lazy(() => import("./views/pages/AccountSettings/AccountSettings")) ;
const ChangePassword = React.lazy(() => import("./views/pages/ChangePassword/ChangePassword")) ;
const Bookmark = React.lazy(() => import("./views/pages/Bookmark/Bookmark")) ;
const Theming = React.lazy(() => import("./hoc/Theming/Theming"));
const RegulationHierarchy = React.lazy(() => import("./views/pages/RegulationHierarchy/RegulationHierarchy"));
const RegulationList = React.lazy(() => import("./views/pages/Regulation/RegulationList/RegulationList"));
const SearchPage = React.lazy(() => import("./views/pages/Search/Search"));
const SearchAzureCognitivePage = React.lazy(() => import("./views/pages/SearchAzureCognitive/SearchAzureCognitive"));
const RegulationCenterUpdate = React.lazy(() => import('./views/pages/RegulationCenterUpdate/RegulationCenterUpdateV2')) ;
const RegframeDashboard = React.lazy(() => import("./views/pages/RegframeDashboard/RegframeDashboard"));
const Dashboard = React.lazy(() => import("./views/pages/Dashboard/Dashboard"));
const Activity = React.lazy(() => import("./views/pages/ActivityList/Activity"))
const ObligationUpdate = React.lazy(() => import("./views/pages/ObligationUpdate"))

// RCS
const ComplianceMonitor = React.lazy(() => import("./views/pages/ComplianceMonitor/ComplianceMonitor"))
const ComplianceMonitorDetail = React.lazy(() => import("./views/pages/ComplianceMonitorDetail/ComplianceMonitorDetail"))
const ComplianceSetting = React.lazy(() => import("./views/pages/ComplianceSetting/ComplianceSetting"))
const ChecklistDetail = React.lazy(() => import("./views/pages/ComplianceMonitorDetail/components/Checklist/ChecklistDetail/ChecklistDetail"))

// DMS
const DocumentManagement = React.lazy(() => import("./views/pages/DocumentManagementV2/DocumentManagement"))

// Static Page
const FormStaticPage = React.lazy(() => import("./views/pages/StaticPage/_FormStaticPage"))
const ListStaticPage = React.lazy(() => import("./views/pages/StaticPage/_ListStaticPage"))
const ContentStaticPage = React.lazy(() => import("./views/pages/StaticPage/ContentStaticPage"))
const InviteUser = React.lazy(() => import("./views/pages/InviteUser/InviteUser"))

function App(props) {
    const { i18n } = useTranslation();
    const { t } = useTranslation();
    const token = localStorage.getItem("token");
    const localModule = localStorage.getItem("modules");
    const modules = useSelector(state => state.user.modules) || JSON.parse(localModule)
    const userProfile = useSelector(state => state.user.profile)
    const complianceDashboardAccess = userProfile  && ( userProfile.company_uuid === window._app_config.REACT_APP_COMPANY_UUID  ?  true : userProfile.product_actions && userProfile.product_actions.management_rcs === "true" )
    const socket = useContext(SocketContext);
    const [onUpdatingContent, setOnUpdatingContent] = useState(null);
    const [onUpdatingContentInfo, setOnUpdatingContentInfo] = useState(null);
    const [onUpdatingContentInfoModal, setOnUpdatingContentInfoModal] = useState(null);
    const [onExpiredInfo, setOnExpiredInfo] = useState('');

    // remove item selectedCompliance every route changes
    localStorage.setItem("selectedCompliance", JSON.stringify([]))

    let query = queryString.parse(props.location.search)
    const dispatch = useDispatch();
    const checkAuth = (token) => dispatch(actions.checkAuth(token));

    const company_uuid = userProfile && userProfile.company_uuid
    const company_name = userProfile && userProfile.company_name
    const isAdminHO = company_uuid === window._app_config.REACT_APP_COMPANY_UUID

    useEffect(() => {
        checkAuth(token);
        // on refresh browser
        socket.emit('rcs-locked-on-updating-content-check');
        socket.emit('rcs-info-updating-content-check');
        socket.emit('rcs-license-check');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        socket.on('rcs-locked-on-updating-content', function(broadcastFromServer) {
            setOnUpdatingContent(broadcastFromServer)
        })
        socket.on('rcs-info-updating-content-show', function(broadcastFromServer) {
            setOnUpdatingContentInfo(broadcastFromServer)
        })
        socket.on('rcs-on-update-content-info', function(broadcastFromServer) {
            setOnUpdatingContentInfoModal(broadcastFromServer);
        })
        socket.on('rcs-license-expired', function(broadcastFromServer) {
            if ( broadcastFromServer ){
                if ( !props.location.pathname.includes('login') && !props.location.pathname.includes('settings/updateSubscription') ) {
                    dispatch(actions.logout())
                }
                setOnExpiredInfo(t('customerManagement.expiredInfoContent'))
            }
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [socket]);

    useEffect(() => {
        // on change location url
        socket.emit('rcs-locked-on-updating-content-check');
        socket.emit('rcs-info-updating-content-check');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.location.pathname]);

    let language = localStorage.getItem('language')
    useEffect(() => {
        i18n.changeLanguage(language);
    }, [language, i18n])

    let route = (
        <Layout showInfo={onUpdatingContentInfo} isModalUpdatingContentShown={onUpdatingContent} >
            { !isAdminHO && onUpdatingContent && !props.location.pathname.includes('settings/updateSubscription')  && (
                <ModalUpdatingContent
                    info={onUpdatingContentInfoModal ? onUpdatingContentInfoModal : null }
                />
            )
            }
            { company_uuid != null && !isAdminHO && window._app_config.REACT_APP_SHOW_FEEDBACK_FORM && <FeedbackForm /> }

            <Suspense fallback={<Loader/>}>
                <Switch>
                    <Route path="/403" exact component={page403} />
                    <Route path="/404" exact component={page404} />

                    <Route path="/" exact
                           render={
                               () => modules &&
                                   (modules.map(mdl => mdl.module_name).includes('Dashboard') ? ( complianceDashboardAccess ? <Dashboard /> : <RegframeDashboard /> ) : modules.map(mdl => mdl.module_name).includes('Regulatory Framework') ?
                                       (<Redirect to="/sector" />) : (<Redirect to="/settings/account" />))
                           }
                    />

                    <Route path='/notification' exact
                           render = {
                               () => (modules && modules.map(mdl => mdl.module_name).includes('Notification')
                                   ?  (<Notification />) : (<Redirect to={'/'}/> ))
                           }
                    />

                    <Route path='/notification/:notifId' exact
                           render = {
                               () => (modules && modules.map(mdl => mdl.module_name).includes('Notification')
                                   ?  (<Notification />) : (<Redirect to={'/'}/> ))
                           }
                    />

                    <Route path='/regulation-update' exact
                           render = {
                               () => (modules && modules.map(mdl => mdl.module_name).includes('Regulation')
                                   ?  (<RegulationCenterUpdate />) : (<Redirect to={'/'}/> ))
                           }
                    />
                    <Route path='/regulation-update/:obligationId' exact
                           render = {
                               () => (modules && modules.map(mdl => mdl.module_name).includes('Notification')
                                   ?  (<RegulationCenterUpdate />) : (<Redirect to={'/'}/> ))
                           }
                    />

                    <Route path='/obligation-update' exact
                           render = {
                               () => (modules && modules.map(mdl => mdl.module_name).includes('Notification')
                                   ?  (<ObligationUpdate />) : (<Redirect to={'/'}/> ))
                           }
                    />
                    <Route path='/obligation-update/:obligationId' exact
                           render = {
                               () => (modules && modules.map(mdl => mdl.module_name).includes('Notification')
                                   ?  (<ObligationUpdate />) : (<Redirect to={'/'}/> ))
                           }
                    />

                    <Route path='/obligation-inactive' exact
                           render = {
                               () => (modules && modules.map(mdl => mdl.module_name).includes('Notification')
                                   ?  (<ObligationUpdate />) : (<Redirect to={'/'}/> ))
                           }
                    />
                    <Route path='/obligation-inactive/:obligationId' exact
                           render = {
                               () => (modules && modules.map(mdl => mdl.module_name).includes('Notification')
                                   ?  (<ObligationUpdate />) : (<Redirect to={'/'}/> ))
                           }
                    />

                    <Route path='/activity' exact
                           render = {
                               () => (modules && modules.map(mdl => mdl.module_name).includes('Activity')
                                   ?  (<Activity />) : (<Redirect to={'/'}/> ))
                           }
                    />

                    <Route path='/library' exact component={RegframeDashboard} />
                    <Route path="/sector-customer/:customerId" exact
                           render = {
                               () => (modules && modules.map(mdl => mdl.module_name).includes('Regulatory Framework')
                                   ?  (<RegFrame />) : (<Redirect to={'/'}/> ))
                           }
                    />
                    <Route path="/sector" exact
                           render = {
                               () => (modules && modules.map(mdl => mdl.module_name).includes('Regulatory Framework')
                                   ?  (<RegFrame />) : (<Redirect to={'/'}/> ))
                           }
                    />
                    <Route path="/sector/:sectorId" exact
                           render = {
                               () => (modules &&  modules.map(mdl => mdl.module_name).includes('Regulatory Framework')
                                   ?  (<RegFrameDetail/>) : (<Redirect to="/403" />))
                           }
                    />
                    <Route
                        path="/sector/:sectorId/:obligationId"
                        exact
                        render = {
                            () => (modules &&  modules.map(mdl => mdl.module_name).includes('Regulatory Framework')
                                ?  (<RegFrameDetail/>) : (<Redirect to="/403" />))
                        }
                    />
                    <Route
                        path="/sector/:sectorId/:obligationId/:code"
                        exact
                        render = {
                            () => (modules && modules.map(mdl => mdl.module_name).includes('Regulatory Framework')
                                ?  (<RegFrameDetail/>) : (<Redirect to="/403" />))
                        }
                    />

                    <Route path="/regulation" exact
                           render = {
                               () => (modules && modules.map(mdl => mdl.module_name).includes('Regulation')
                                   ?  (<RegulationHierarchy />) : (<Redirect to="/403" />))
                           }
                    />
                    <Route path="/regulation/list/:id" exact
                           render = {
                               () => (modules && modules.map(mdl => mdl.module_name).includes('Regulation')
                                   ?  (<RegulationList />) : (<Redirect to="/403" />))
                           }
                    />
                    <Route
                        path="/regulation/:id"
                        exact
                        render = {
                            () => (modules && modules.map(mdl => mdl.module_name).includes('Regulation')
                                ?  (<RegulationDetail />) : (<Redirect to="/403" />))
                        }
                    />

                    <Route
                        path="/customer-management"
                        exact
                        render = {
                            () => (modules && modules.map(mdl => mdl.module_name).includes('Customer Management')
                                ?  (<CustomerManagement />) : (<Redirect to="/403" />))
                        }
                    />
                    <Route
                        path="/customer-management/:customerId"
                        exact
                        render = {
                            () => (modules && modules.map(mdl => mdl.module_name).includes('Customer Management')
                                ?  (<DetailCustomer />) : (<Redirect to="/403" />))
                        }
                    />


                    <Route path="/user-management" exact
                           render = {
                               () => (modules && modules.map(mdl => mdl.module_name).includes('User Management')
                                   ?  (<UserManagement />) : (<Redirect to="/403" />))
                           }
                    />
                    <Route path="/user-management/group/:groupId" exact
                           render = {
                               () => (modules && modules.map(mdl => mdl.module_name).includes('User Management')
                                   ?  (<DetailGroup />) : (<Redirect to="/403" />))
                           }
                    />

                    <Route path="/settings" exact
                           render = {
                               () => (modules && modules.map(mdl => mdl.module_name).includes('Settings')
                                   ?  (<Settings />) : (<Redirect to="/403" />))
                           }
                    />
                    <Route path="/settings/account" exact
                           render = {
                               () => (<AccountSettings />)
                           }
                    />
                    <Route path="/settings/account/change-password" exact
                           render = {
                               () => (<ChangePassword />)
                           }
                    />
                    <Route
                        path="/settings/notification"
                        exact
                        render = {
                            () => (modules && modules.map(mdl => mdl.module_name).includes('Settings')
                                ?  (<SettingNotification />) : (<Redirect to="/403" />))
                        }
                    />
                    <Route path="/settings/theme" exact
                           render = {
                               () => (modules && modules.map(mdl => mdl.module_name).includes('Settings')
                                   ?  (<ThemeSetting />) : (<Redirect to="/403" />))
                           }
                    />

                    <Route path="/settings/updateSubscription" exact component={SubscriptionUpdate} />

                    <Route path="/bookmark" exact component={Bookmark} />

                    <Route path="/search/:category" exact component={ window._app_config.REACT_APP_SEARCH_SERVICE && window._app_config.REACT_APP_SEARCH_SERVICE.toLowerCase() === 'azure-cognitive-search' ? SearchAzureCognitivePage : SearchPage} />
                    {/* RCS */}
                    <Route path="/compliance-monitor" exact
                           render = {
                               () => (modules && modules.map(mdl => mdl.module_name).includes('Compliance Monitor')
                                   ?  (<ComplianceMonitor />) : (<Redirect to="/403" />))
                           }
                    />
                    <Route path="/compliance-monitor/:complianceId" exact
                           render = {
                               () => (modules && modules.map(mdl => mdl.module_name).includes('Compliance Monitor')
                                   ?  (<ComplianceMonitorDetail />) : (<Redirect to="/403" />))
                           }
                    />
                    <Route path="/compliance-monitor/:complianceId/setting" exact
                           render = {
                               () => (modules && modules.map(mdl => mdl.module_name).includes('Compliance Monitor')
                                   ?  (<ComplianceSetting />) : (<Redirect to="/403" />))
                           }
                    />
                    <Route path="/compliance-monitor/:complianceId/checklist/:checklistId" exact
                           render = {
                               () => (modules && modules.map(mdl => mdl.module_name).includes('Compliance Monitor')
                                   ?  (<ChecklistDetail />) : (<Redirect to="/403" />))
                           }
                    />


                    {/* DMS */}
                    <Route path="/document" exact
                           render = {
                               () => (modules && modules.map(mdl => mdl.module_name).includes('Document Management')
                                   ?  (<DocumentManagement />) : (<Redirect to="/403" />))
                           }
                    />
                    <Route path="/document/:complianceId" exact
                           render = {
                               () => (modules && modules.map(mdl => mdl.module_name).includes('Document Management')
                                   ?  (<DocumentManagement />) : (<Redirect to="/403" />))
                           }
                    />
                    <Route path="/document/:complianceId/list/:checklistId" exact
                           render = {
                               () => (modules && modules.map(mdl => mdl.module_name).includes('Document Management')
                                   ?  (<DocumentManagement />) : (<Redirect to="/403" />))
                           }
                    />
                    <Route path="/document/preview/:documentId" exact
                           render = {
                               () => (modules && modules.map(mdl => mdl.module_name).includes('Document Management')
                                   ?  (<DocumentManagement />) : (<Redirect to="/403" />))
                           }
                    />

                    {/* static pages */}
                    <Route path="/static-pages" exact
                           render = {
                               () => modules && modules.map(mdl => mdl.module_name).includes('Content') ?  (<ListStaticPage/>) : (<Redirect to="/403" />)
                           }
                    />
                    <Route path="/static-pages/create" exact
                           render = {
                               () => modules && modules.map(mdl => mdl.module_name).includes('Content') ?  (<FormStaticPage/>) : (<Redirect to="/403" />)
                           }
                    />
                    <Route path="/static-pages/:slug" exact
                           render = {
                               () => modules && modules.map(mdl => mdl.module_name).includes('Content') ?  (<FormStaticPage/>) : (<Redirect to="/403" />)
                           }
                    />
                    <Route path="/content/:slug" component={ContentStaticPage} />
                    <Redirect to={query.redirect || '/'} />
                </Switch>
            </Suspense>
        </Layout>
    );

    if (!token) {
        route = (
            <Suspense fallback={<Loader/>}>
                <Switch>
                    <Route path="/login" exact render = {() => (<Login onExpiredInfo={onExpiredInfo} />)} />
                    <Route path="/recovery-password" exact render = {() => (<Login onExpiredInfo={onExpiredInfo} />)} />
                    <Route path="/recovery-password/change" exact render = {() => (<Login onExpiredInfo={onExpiredInfo} />)} />
                    <Route path="/content/:slug" component={ContentStaticPage} />
                    <Route path="/settings/updateSubscription" exact component={SubscriptionUpdate} />
                    <Route path="/invite-user" exact component={InviteUser} />
                    <Redirect
                        to={{
                            pathname: "/login",
                            state: { prevPath: props.location.pathname },
                        }}
                    ></Redirect>
                </Switch>
            </Suspense>
        );
    }

    if (props.location.state && props.location.state.prevPath && props.location.state.prevPath !== '/') {
        props.history.push(`/login?redirect=${props.location.state.prevPath}`);
    }

    if (company_uuid != null && !isAdminHO && window._app_config.REACT_APP_GTM_ID) {
        const tagManagerArgs = {
            gtmId: window._app_config.REACT_APP_GTM_ID,
            dataLayer: {
                event: 'SendUserInfo',
                'Company_Name': company_name,
            }
        };

        TagManager.initialize(tagManagerArgs)
    }

    return (<Theming>{route}</Theming>);
}

export default withRouter(App);
